import React, { useEffect, useRef, useState } from "react";
import { ApiService } from "../../Component/services/apiServices";
import Alert from 'react-bootstrap/Alert';
import AccountHeader from "../../Component/Header/account_header";
const ContactUs = () => {
  const didMountRef = useRef(true);
  const [contactInputs, setcontactInputs] = useState({
    contact_name: "",
    contact_email: "",
    contact_mobile: "",
    contact_subject: "",
    contact_message: "",
  });
  const [errorMessage, seterrorMessage] = useState(false)
  const [successMessage, setsuccessMessage] = useState(false)
const [buttonLoader, setButtonLoader] = useState(false)
  useEffect(() => {
    if (didMountRef.current) {
    }
    didMountRef.current = false;
  });

  const handleContactInput = (e) => {
    seterrorMessage('')
    const { name, value } = e.target;
    setcontactInputs({
      ...contactInputs,
      [name]: value,
    });
  };

  const ContactformHandle = () => {
    let counter = 0;
    const myElements = document.getElementsByClassName("required");
    for (let i = 0; i < myElements.length; i++) {
      if (myElements[i].value === '') {
        myElements[i].style.border = '1px solid red';
        counter++;
      } else {
        myElements[i].style.border = '';
      }
    }
    if (counter === 0) {
      if (contactInputs?.contact_name === "") {
        seterrorMessage('Please Enter Your Name')
        return;
      }
      if (contactInputs?.contact_email === "") {
        seterrorMessage('Please Enter Your Email Address')
        return;
      }
      const validEmail = new RegExp("^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$");
      if (!validEmail.test(contactInputs?.contact_email)) {
        seterrorMessage('Please Enter Valid Email Address');
        return;
      }
      if (contactInputs?.contact_mobile === "") {
        seterrorMessage('Please Enter Your Mobile Number');
        return;
      }

      if (contactInputs?.contact_message === "") {
        seterrorMessage('Please Enter Your Message');
        return;
      }
      setButtonLoader(true);
      ApiService.postData("contact-us-process", contactInputs).then(
        (res) => {
          if (res?.status === "success") {
            setsuccessMessage(res?.message)
            setcontactInputs({ contact_name: "", contact_email: "", contact_mobile: "", contact_subject: "", contact_message: "", })
            setButtonLoader(false);
          } else if (res?.status === "error") {
            seterrorMessage(res?.message);
            setButtonLoader(false);
          }
        }
      );
    }
  };
  return (
    <>
      <AccountHeader heading={'Contact Us'}></AccountHeader>
      <div id='appCapsule'>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>Get In Touch With Us</h2>
                <p>If you have any questions or enquiries please feel free to contact us alternatively you can complete our online enquiry form located below and we will get back to you as soon as possible.</p>
              </div>
              {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
              {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
              <div className="row g-3">
                <div className="col-lg-6">
                  <div className="form-group"><label>Your Name</label><input type="text" name="contact_name" className="form-control required" placeholder="Name" onChange={(e) => { handleContactInput(e) }} value={contactInputs?.contact_name} /></div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group"><label>Email Address</label><input type="email" name="contact_email" className="form-control required" placeholder="Email" onChange={(e) => { handleContactInput(e) }} value={contactInputs?.contact_email} /></div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group"><label>Mobile Number</label><input type="number" name="contact_mobile" className="form-control required" placeholder="Mobile Number" onChange={(e) => { handleContactInput(e) }} value={contactInputs?.contact_mobile} /></div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group"><label>Subject</label><input type="text" name="contact_subject" className="form-control required" placeholder="Subject" onChange={(e) => { handleContactInput(e) }} value={contactInputs?.contact_subject} /></div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group"><label>Message</label><textarea name="contact_message" className="form-control required" onChange={(e) => { handleContactInput(e) }} value={contactInputs?.contact_message}></textarea></div>
                </div>
                <div className="ccpanel-footer">
                  <button
                    className="btn btn-primary btn-full btn-lg mt-10 mb-5"
                    type="button"
                    name="submit"
                    onClick={(e) => { ContactformHandle(e) }}
                    disabled={buttonLoader}
                  >
                    {buttonLoader ? <img loading="lazy" src="/img/loder01.gif" alt="Loading..." width="90" height="15" /> : 'Submit'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default ContactUs